import { Component, Input } from '@angular/core';
import { ContainerMovementListItem } from '../../../Container/model/ContainerMovementListItem';
import { DatePipe } from '@angular/common';
import { DateTimeHelper } from '../../../DateTime/DateTimeHelper';

@Component({
  selector: 'app-container-job-leg-details',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './container-job-leg-details.component.html',
  styleUrl: './container-job-leg-details.component.scss'
})
export class ContainerJobLegDetailsComponent {

  @Input()
  containerLegsData?: ContainerMovementListItem[] = [];

  getCompletedDate(date: Date | null | undefined): Date | null {
    return date ? DateTimeHelper.utcToLocal(date) : null;
  }
}
